"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Correspond to the 'types' of entities in the directory service
 * that can be called.
 */
var CallableTypes;
(function (CallableTypes) {
    CallableTypes["USER"] = "user";
    CallableTypes["MEETING"] = "meeting";
    CallableTypes["ROOM"] = "room";
    CallableTypes["PERSONAL"] = "personal";
    CallableTypes["GROUP"] = "group";
})(CallableTypes = exports.CallableTypes || (exports.CallableTypes = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/constants/lib/callable-types.js
// module id = 735
// module chunks = 0